import Request from "./request";
import qs from "qs";
const loginWxScan = "/login/wechat/qrurl";
const loginWx = "/login/wechat";
const Verification = "/sendVerifyCode";
const login = "/login/mobile";
const userLogin = "/user/mobile";

export default {
  //获取验证码
  async getVerification(query) {
    return Request.post(Verification, {
      mobile: query.mobile,
      tpl: query.tpl
    });
  },
  //手机号登录
  async LoginMobile(query) {
    let data = {
      mobile: query.mobile,
      code: query.code,
      token: query.token
    };
    return Request.post(
      login,
      qs.stringify(data),
      "application/x-www-form-urlencoded"
    );
  },
  //微信跳转扫码
  async LoginWeChatScan(url) {
    return Request.post(loginWxScan, {
      appId: "wx33bc1debb6840ca0",
      redirectUri: url
    });
  },
  //微信登录
  async LoginWeChat(appId, code) {
    let data = {
      appId: appId,
      code: code
    };
    return Request.post(
      loginWx,
      qs.stringify(data),
      "application/x-www-form-urlencoded"
    );
  },
  //修改手机号
  async editPhone(query) {
    return Request.put(userLogin, query, "application/x-www-form-urlencoded");
  }
};
